import component from './manageLocations.vue';
export const MANAGE_LOCATIONS = 'manageLocations';

export default{
    id: MANAGE_LOCATIONS,
    component,
}
